import React from "react";
import moment from "moment";
import { Icon } from "antd";
import "./LastCheckedDate.less";

type Props = {
    checkedAt: string;
}

export default function LastCheckedDate({ checkedAt }: Props) {
    return (
        <span className="last-checked-date">
            <Icon type="clock-circle" />
            Last checked on {moment.utc(checkedAt).local().format("MMM DD, YYYY [at] hh:mm A")}
        </span>
    );
}
